

































import Vue from 'vue'
import StripePaymentCard from '@/components/StripePaymentCard.vue'
import { signoutConfirm } from '@/utility/helpers'
export default Vue.extend({
    components: {
        StripePaymentCard
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        query(): string | null {
            //  If query params exist, return string format
            if (this.$route.query) return '?' + window.toUrlParams(this.$route.query)

            //  Else, return nothing
            return null
        }
    },
    methods: {
        billingPaymentFormSubmitted(): void {
            // Route user to building screen
            this.$router.push(`/register/building${this.query || ''}`)
        },
        handleSignOut(): void {
            signoutConfirm()
        },
    }
})
